export default {
  switch: "Switch Language",
  zhCN: "Simplified Chinese",
  zhHK: "Traditional Chinese",
  en: "English",
};
